export default {
  nomeErrors() {
    const errors = []
    if (!this.$v.item.name.$dirty) return errors
    !this.$v.item.name.required && errors.push('Nome obrigatório!')
    return errors
  },

  contractTypeIdErrors() {
    const errors = []
    if (!this.$v.item.contractTypeId.$dirty) return errors
    !this.$v.item.contractTypeId.required && errors.push('Campo obrigatório!')
    return errors
  },

  ggrAliquotErrors() {
    const errors = []
    if (!this.$v.item.ggrAliquot.$dirty) return errors
    !this.$v.item.ggrAliquot.required && errors.push('Campo Obrigatório!')
    return errors
  },

  valueErrors() {
    const errors = []
    if (!this.$v.item.value.$dirty) return errors
    !this.$v.item.value.required && errors.push('Campo Obrigatório!')
    return errors
  },

  gameValueErrors() {
    const errors = []
    if (!this.$v.item.gameValue.$dirty) return errors
    !this.$v.item.gameValue.required && errors.push('Campo Obrigatório!')
    return errors
  },

  minRangeErrors() {
    const errors = []
    if (!this.$v.itemValueRange.minRange.$dirty) return errors
    if (!this.$v.itemCassino.itemValueRange.minRange.$dirty) return errors
    if (!this.$v.itemProg.itemValueRange.minRange.$dirty) return errors
    !this.$v.itemValueRange.minRange.required && errors.push('Campo Obrigatório!')
    !this.$v.itemCassino.itemValueRange.minRange.required && errors.push('Campo Obrigatório!')
    !this.$v.itemProg.itemValueRange.minRange.required && errors.push('Campo Obrigatório!')
    return errors
  },

  maxRangeErrors() {
    const errors = []
    if (!this.$v.itemValueRange.maxRange.$dirty) return errors
    if (!this.$v.itemCassino.itemValueRange.maxRange.$dirty) return errors
    if (!this.$v.itemProg.itemValueRange.maxRange.$dirty) return errors
    !this.$v.itemValueRange.maxRange.required || !this.$v.itemCassino.itemValueRange.maxRange.required || !this.$v.itemProg.itemValueRange.maxRange.required && errors.push('Campo Obrigatório!')
    !this.$v.itemValueRange.maxRange.minValueExist || !this.$v.itemCassino.itemValueRange.maxRange.minValueExist || !this.$v.itemProg.itemValueRange.maxRange.minValueExist && errors.push('Valor muito baixo!')
    !this.$v.itemValueRange.maxRange.minValue || !this.$v.itemCassino.itemValueRange.maxRange.minValue || !this.$v.itemProg.itemValueRange.maxRange.minValue && errors.push('Valor muito baixo!')
    return errors
  },

  typeOperatorErrors() {
    const errors = []
    if (!this.$v.itemOperator.fieldId.$dirty) return errors
    !this.$v.itemOperator.fieldId.required && errors.push('Campo Obrigatório!')
    !this.$v.itemOperator.fieldId.isValidField && errors.push('Já existe!')
    return errors
  },

  conditionOperatorErrors() {
    const errors = []
    if (!this.$v.itemOperator.operator.$dirty) return errors
    !this.$v.itemOperator.operator.required && errors.push('Campo Obrigatório!')
    !this.$v.itemOperator.operator.isValidOperation && errors.push('Já existe!')

    return errors
  },

  valueOperatorErrors() {
    const errors = []
    if (!this.$v.itemOperator.value.$dirty) return errors
    !this.$v.itemOperator.value.minValue && errors.push('Digite um valor maior!')
    !this.$v.itemOperator.value.required && errors.push('Campo Obrigatório!')
    !this.$v.itemOperator.value.isValidValue && errors.push('Valor muito baixo!')

    return errors
  },

  comissionTypeIdErrors() {
    const errors = []
    if (!this.$v.itemPagamentos.comissionTypeId.$dirty) return errors
    !this.$v.itemPagamentos.comissionTypeId.required && errors.push('Campo obrigatório!')
    return errors
  },
}